import React, { useEffect, useState } from "react"

import Ding from "assets/ding.mp3"

import { Button } from "~tailwindui/Basics"
import Modal from "~tailwindui/Modal"

import EventEmitter from "src/EventEmitter"

const IncomingStudentsModal = () => {
  const [incomingStudents, setIncomingStudents] = useState(false)

  useEffect(() => {
    const onIncomingStudents = () => {
      setIncomingStudents(true)
      new Audio(Ding).play()
    }
    EventEmitter.subscribe("incoming_students", onIncomingStudents)

    return () =>
      EventEmitter.unsubscribe("incoming_students", onIncomingStudents)
  }, [])

  return (
    <Modal.Dialog
      hideButton
      isOpen={incomingStudents}
      closeModal={() => setIncomingStudents(false)}
    >
      {closeModal => (
        <>
          <Modal.Header>Incoming Students</Modal.Header>

          <Modal.Body>
            <p className="lead">
              Another tutor was unable to make their session. One or more
              students have been reassigned to your session and will be joining
              momentarily.
            </p>
          </Modal.Body>

          <Modal.Footer>
            <div className="flex justify-end space-x-2">
              <Button onClick={closeModal}>Dismiss</Button>
            </div>
          </Modal.Footer>
        </>
      )}
    </Modal.Dialog>
  )
}

export default IncomingStudentsModal
